import { cn } from '@/shared/lib/cn'

/**
 * The small label above a section heading.
 *
 * Was an eight-class utility string repeated on every page; the leading rule
 * makes it read as a deliberate typographic device rather than just small
 * caps. `tone` switches it for dark brand bands.
 */
export function Eyebrow({
  children,
  tone = 'default',
  className,
}: {
  children: string
  tone?: 'default' | 'inverse'
  className?: string
}) {
  return (
    <p
      className={cn(
        'flex items-center gap-2.5 text-xs font-semibold tracking-[0.14em] uppercase',
        tone === 'inverse' ? 'text-brand-300' : 'text-brand-600',
        className,
      )}
    >
      <span
        aria-hidden="true"
        className={cn(
          'h-px w-6 shrink-0',
          tone === 'inverse' ? 'bg-brand-400/60' : 'bg-brand-300',
        )}
      />
      {children}
    </p>
  )
}
